import { createContext, useCallback, useContext } from "react";
import type { SelectionTone } from "../Card/SelectionCard";
type SelectionMode = "radio" | "checkbox" | "switch";
type SelectionGroupContextValue = {
  mode: SelectionMode;
  isSelected: (value: string) => boolean;
  onSelect: (value: string) => void;
  disabled: boolean;
  showSelector: boolean;
  tone: SelectionTone;
};
const SelectionGroupContext = createContext<SelectionGroupContextValue | null>(null);
const useSelectionGroup = (): SelectionGroupContextValue => {
  const ctx = useContext(SelectionGroupContext);
  if (!ctx) {
    throw new Error("useSelectionGroup must be used within a SelectionGroup");
  }
  return ctx;
};
const useSelectionItem = (value: string, disabledProp?: boolean) => {
  const group = useSelectionGroup();
  const disabled = group.disabled || disabledProp === true;
  const selected = group.isSelected(value);
  const onPress = useCallback(() => {
    group.onSelect(value);
  }, [group, value]);
  return {
    group,
    disabled,
    selected,
    onPress: disabled ? undefined : onPress
  };
};
export type { SelectionMode };
export { SelectionGroupContext, useSelectionGroup, useSelectionItem };